import { ApplicationUser } from "@src/apis/ModularClient";

export class DeveloperExitFinanceComparisonController {
  isLoading: boolean;

  exitLoanCriteria: any; //Changed from DeveloperExitFinanceInputSet to any, change back if used.

  selectedCandidates: any[]; //DeveloperExitFinanceResult

  selectedUser: ApplicationUser;

  enquiryOpen: boolean;
  enquiryEmail: string;
  enquiryBody: string;

  static $inject = ["$scope", "$rootScope", "$cookies", "$location", "$http"];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
  ) {
    this.selectedUser = (this.$rootScope as any).selectedUser;

    this.selectedCandidates = (this.$rootScope as any).comparisonList;
    this.exitLoanCriteria = (this.$rootScope as any).exitLoanCriteria;

    if (!this.selectedCandidates || !this.exitLoanCriteria) {
      this.$location.path("/");
    }
  }

  sendEnquiry(): void {
    this.enquiryOpen = false;
  }

  go(path): void {
    this.$location.path(path);
  }
}
